<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon
  ><span>{{ "btn:close" | translate }}</span>
</div>
<div class="modal-header">
  <h4 class="modal-title">
    {{ "start:course:modal:title" | translate }}
  </h4>
</div>
<div class="modal-body">
  <div class="form-group">
    <p>{{ "start:course:modal:description" | translate }}</p>
    <p class="fw-bold">{{ courseName }}</p>
    <p>{{ "start:course:modal:question" | translate }}</p>
  </div>
</div>

<div class="modal-footer">
  <div class="form-group clearfix">
    <button
      (click)="closeModal()"
      type="button"
      role="tab"
      class="btn btn-outline-secondary float-right ms-2 fs-15"
    >
      {{ "btn:cancel" | translate }}
    </button>

    <button
      (click)="confirmStart()"
      type="button"
      role="tab"
      class="btn btn-primary float-right ms-2 fs-15"
      [disabled]="loadSpin"
    >
      <fa-icon
        class="me-2"
        [icon]="faCircleNorch"
        *ngIf="loadSpin"
        [spin]="true"
      ></fa-icon>
      {{ "start:course:modal:button:confirm" | translate }}
    </button>
  </div>
</div>
